import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  defaultDuplicateFormState,
  type DuplicateFormState,
} from "@/lib/duplicateProductOptions";

const DUPLICATE_FIELDS: { key: keyof DuplicateFormState; label: string }[] = [
  { key: "copyImage", label: "Slika" },
  { key: "copyName", label: "Naziv" },
  { key: "copySku", label: "SKU" },
  { key: "copyPrice", label: "Osnovna cijena" },
  { key: "copySalePrice", label: "Akcijska cijena" },
  { key: "copyCondition", label: "Stanje oštećenja" },
  { key: "copyCategory", label: "Kategorija" },
  { key: "copyQuantity", label: "Količina" },
  { key: "copySize", label: "Veličina" },
  { key: "copyBinLocation", label: "Lokacija (bin)" },
];

interface DuplicateProductDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  options: DuplicateFormState;
  onOptionChange: (key: keyof DuplicateFormState, value: boolean) => void;
  productName: string | null;
  productSku: string | null;
  onConfirm: () => void;
  isPending: boolean;
}

export default function DuplicateProductDialog({
  open,
  onOpenChange,
  options,
  onOptionChange,
  productName,
  productSku,
  onConfirm,
  isPending,
}: DuplicateProductDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(open) => {
      onOpenChange(open);
    }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Dupliraj proizvod</DialogTitle>
          <DialogDescription>
            Odaberite koje podatke kopirati u novi zapis. Ako isključite SKU ili kategoriju, ta polja ostanu
            prazna dok ih ne unesete.
          </DialogDescription>
        </DialogHeader>
        {productName && (
          <p className="text-sm text-muted-foreground -mt-1 mb-1">
            Izvor: <span className="font-medium text-foreground">{productName}</span>
            {productSku != null && productSku !== "" && (
              <span className="text-muted-foreground"> · {productSku}</span>
            )}
          </p>
        )}
        <div className="grid gap-2 py-1 max-h-[min(50vh,22rem)] overflow-y-auto pr-1">
          {DUPLICATE_FIELDS.map(({ key, label }) => (
            <label
              key={key}
              className="flex items-center gap-2.5 rounded-md border border-border/60 bg-muted/20 px-3 py-2 text-sm cursor-pointer hover:bg-muted/35"
            >
              <Checkbox
                checked={options[key]}
                onCheckedChange={(c) => onOptionChange(key, c === true)}
              />
              <span>{label}</span>
            </label>
          ))}
        </div>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            Odustani
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            disabled={isPending}
          >
            {isPending ? "Kreiranje…" : "Kreiraj duplikat"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
